import { Subject } from 'rxjs';
export class DashboardRealTimeMonitoringService {
    constructor() {
        this.monitoringScreenRefreshAlert$ = new Subject();
    }
    getMonitoringScreenRefreshAlert() {
        return this.monitoringScreenRefreshAlert$.asObservable();
    }
    refreshMonitoringScreen() {
        this.monitoringScreenRefreshAlert$.next();
    }
}
